(function () {
  "use strict";
  window.escapeHtml = function (str) {
    if (str == null) return "";
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  window.safeTag = function (tag, fallback) {
    var t = String(tag == null ? "" : tag).trim().toLowerCase();
    return /^(h[1-6]|p|span|div|strong|em)$/.test(t) ? t : (fallback || "h2");
  };
  window.safeUrl = function (url) {
    if (url == null) return "";
    var s = String(url).trim();
    if (/^(https?:)?\/\//i.test(s) || s.charAt(0) === "/" || s.charAt(0) === "#") return window.escapeHtml(s);
    return ""; // rejects javascript:, data:, vbscript:, etc.
  };
})();
